


















import Vue from 'vue'
import { mapActions } from 'vuex'
import { RootActionNames } from '@/store'
import moment from 'moment-timezone'
import { buildBarChartOptions, buildDataPointsByDay, fillDate } from '@/components/patient-stats/common/utils'
import * as R from 'ramda'
import { DataPoint } from '@/jsonapi/CommonTypes'
import { CHART_DATE_FORMAT } from '@/components/patient-stats/constants'
import { removeAbbr, USER_TIME_ZONE } from '@/utils/time'
import ChartCardContainer from '@/components/layouts/ChartCardContainer.vue'
import { buildCasualNumberOfStepsOptions } from '@/components/patient-stats/graphs/detailed-reports/options/casual-number-of-steps-options'

export default Vue.extend({
  components: {
    ChartCardContainer,
  },
  props: {
    patientId: {
      type: String,
      required: true,
    },
    patientWithStats: {
      type: Object,
      required: true,
    },
    patientWithDetailedReports: {
      type: Object,
      required: true,
    },
  },
  computed: {
    startTimestamp() {
      return this.patientWithStats.resultStartTimestamp
    },
    endTimestamp() {
      return this.patientWithStats.resultEndTimestamp
    },
    timezone() {
      return this.patientWithStats.timezone
    },
    casualWalkSteps(): DataPoint[] {
      debugger
      return R.pathOr([], ['activityReport', 'casualWalkSteps'], this.patientWithDetailedReports)
    },
    buildOptions() {
      debugger
      const { resultStartTimestamp, resultEndTimestamp } = this.patientWithDetailedReports
      const timezone = this.patientWithDetailedReports.timezone || USER_TIME_ZONE
      return {
        resultStartTimestamp,
        resultEndTimestamp,
        timezone,
        colors: this.$vuetify.theme.themes.light,
      }
    },
    casualNumberOfStepsOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      debugger
      return buildCasualNumberOfStepsOptions({
        ...this.buildOptions,
        casualWalkSteps: this.casualWalkSteps,
      })
    },
    // unused for now. Confusing since it doesn't match the app or detailed tab
    // nonCasualStepCountsChartOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
    //   if (!this.patientWithStats || !this.patientWithStats.stepCounts || !this.patientWithStats.stepCounts.length) {
    //     return null
    //   }
    //
    //   const { stepCounts, resultStartTimestamp, resultEndTimestamp } = this.patientWithStats
    //   const timezone = this.patientWithStats.timezone || USER_TIME_ZONE
    //
    //   // @ts-ignore
    //   const eqByTimestamps = R.curry(R.eqProps)('timestamp')
    //   const uniqStepCounts = R.uniqWith(eqByTimestamps)(stepCounts) as DataPoint[]
    //   // console.log("Data points: ");
    //   // console.log(uniqStepCounts)
    //   // const datapoints = uniqStepCounts.map(function(item) {
    //   //   return { timestamp: item.timestamp, value: item.value }
    //   // }) as DataPoint[]
    //
    //   const stepCountsByDayMap: { [key: string]: number } = buildDataPointsByDay(uniqStepCounts, timezone)
    //   const xAxisLabels: string[] = [...fillDate(timezone, resultStartTimestamp, resultEndTimestamp)].map(timestamp =>
    //     String(timestamp)
    //   )
    //   const seriesXData: Array<[string, number]> = Object.entries(stepCountsByDayMap)
    //   const maxYValue = Math.max(...Object.values(stepCountsByDayMap), 5000)
    //
    //   return buildBarChartOptions({
    //     baseColor: this.$vuetify.theme.themes.light.teal,
    //     lowValueColor: this.$vuetify.theme.themes.light.burgundy,
    //     threshold: 3000,
    //     minYValue: 50,
    //     maxYValue,
    //     seriesXData,
    //     xAxisLabels,
    //     tooltipFormatter: this.getFormatter(timezone, 'steps'),
    //     timezone,
    //   })
    // },
  },

  methods: {
    getFormatter(timezone, unit): (params: any) => string {
      return params => {
        // @ts-ignore
        const [timestamp, value] = params.data.value
        const dateText = moment(parseInt(timestamp, 10))
          .tz(timezone)
          .format(removeAbbr(timezone, CHART_DATE_FORMAT.DAY_ABBR))
        return `${dateText}\n${value} ${value <= 1 ? unit.slice(0, -1) : unit}`
      }
    },
  },
})
